
gsap.registerPlugin(ScrollTrigger);

/* ========================= MOBILE FIX ========================= */
ScrollTrigger.normalizeScroll(true);
ScrollTrigger.config({
  ignoreMobileResize: true
});

/* ========================= VIEWPORT FIX ========================= */
function getViewport() {
  if (window.visualViewport) {
    return {
      width: window.visualViewport.width,
      height: window.visualViewport.height
    };
  }
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}

function updateViewport() {
  const vp = getViewport();

  camera.aspect = vp.width / vp.height;
  camera.updateProjectionMatrix();

  renderer.setSize(vp.width, vp.height);
}

const vp = getViewport();

/* ========================= SIZE ========================= */
const ENTRY_SCALE     = 18;
const BIG_SCALE       = 24;
const SECTION5_SCALE  = 16;

const LOWER_Y = -8.5;
const FALL_Y  = -4.5;

const HERO_Z_START = 8;

/* ========================= SCENE ========================= */
const scene = new THREE.Scene();

const camera = new THREE.PerspectiveCamera(
  45,
  vp.width / vp.height,
  0.1,
  200
);

camera.position.set(0, 1.5, HERO_Z_START);

const renderer = new THREE.WebGLRenderer({
  canvas: document.getElementById("c"),
  alpha: true,
  antialias: true
});

renderer.setSize(vp.width, vp.height);
renderer.setPixelRatio(Math.min(devicePixelRatio, 1.5));
renderer.outputColorSpace = THREE.SRGBColorSpace;
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1.2;

/* 🔥 FIX: handle mobile viewport changes */
window.visualViewport?.addEventListener("resize", updateViewport);
window.visualViewport?.addEventListener("scroll", updateViewport);

/* ========================= LIGHT ========================= */
const pmrem = new THREE.PMREMGenerator(renderer);

new THREE.TextureLoader().load(
  "https://threejs.org/examples/textures/equirectangular/royal_esplanade_1k.jpg",
  (texture) => {
    texture.mapping = THREE.EquirectangularReflectionMapping;
    const envMap = pmrem.fromEquirectangular(texture).texture;
    scene.environment = envMap;
    texture.dispose();
    pmrem.dispose();
  }
);

scene.add(new THREE.AmbientLight(0xffffff, 1.0));

const light = new THREE.DirectionalLight(0xffffff, 1.3);
light.position.set(5, 10, 8);
scene.add(light);

/* ========================= MODEL ========================= */
let bottle;
let mixer = null;
let action = null;
const clock = new THREE.Clock();

/* ========================= LOAD ========================= */
new THREE.GLTFLoader().load("https://cdn.shopify.com/3d/models/c0c0a7b6fe5eff80/newanime.glb", (gltf) => {

  bottle = gltf.scene;

  bottle.scale.set(ENTRY_SCALE, ENTRY_SCALE, ENTRY_SCALE);
  bottle.position.set(0, LOWER_Y, 20);
  bottle.rotation.set(-0.35, 0, 0);

  scene.add(bottle);

  ScrollTrigger.clearScrollMemory();
  window.scrollTo(0, 0);

  bottle.traverse((child) => {
    if (child.isMesh) {
      const box = new THREE.Box3().setFromObject(child);
      const size = new THREE.Vector3();
      box.getSize(size);

      if (size.x > 3 || size.z > 3) {
        child.userData.isBox = true;
        child.visible = false;
      }
    }
  });

  if (gltf.animations.length > 0) {
    mixer = new THREE.AnimationMixer(bottle);
    action = mixer.clipAction(gltf.animations[0]);

    action.setLoop(THREE.LoopOnce);
    action.clampWhenFinished = true;
    action.play();
    action.paused = true;
  }

  buildScroll();
  initSnakeLines();
});

/* ========================= RENDER ========================= */
function render() {
  requestAnimationFrame(render);

  if (mixer) mixer.update(clock.getDelta());

  renderer.render(scene, camera);
}
render();

/* ========================= SCROLL ========================= */
function buildScroll() {

  /* ========================= INTRO ========================= */
  gsap.timeline({
    scrollTrigger: {
      trigger: ".intro",
      start: "top top",
      end: "+=60%",
      scrub: true,
      pin: true
    }
  })
  .to(".intro .card", { opacity: 1, y: 0 })
  .to(bottle.position, { z: 0 }, 0)
  .to(bottle.rotation, { x: 0 }, 0)
  .to(bottle.scale, {
    x: BIG_SCALE,
    y: BIG_SCALE,
    z: BIG_SCALE,
    ease: "power2.out"
  }, 0.6);


  /* ========================= PANEL ANIM ========================= */
  document.querySelectorAll(".panel").forEach(panel => {
    const card = panel.querySelector(".card");

    if (card) {
      gsap.from(card, {
        opacity: 0,
        y: 60,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: panel,
          start: "top 75%"
        }
      });
    }
  });


  /* ========================= ROTATION ========================= */
  gsap.to(bottle.rotation, {
    y: "+=" + Math.PI * 4,
    ease: "none",
    scrollTrigger: {
      trigger: ".three-scroll-container",
      start: "top top",
      end: "bottom bottom",
      scrub: 1.3
    }
  });


  /* ========================= SECTION 5 CONTROL ========================= */
  let isActive = false;

  ScrollTrigger.create({
    trigger: ".section5",
    start: "top top",
    end: "+=150%",
    scrub: 1.5,
    pin: true,
    invalidateOnRefresh: true,

    onEnter: () => isActive = true,
    onEnterBack: () => isActive = true,

    onLeave: () => isActive = false,

    onLeaveBack: () => {
      isActive = false;

      // 🔥 restore PERFECT state for section 4
      gsap.set(bottle.scale, {
        x: BIG_SCALE,
        y: BIG_SCALE,
        z: BIG_SCALE,
         duration: 0.3,
  ease: "power2.out",
  overwrite: true
      });

      gsap.set(bottle.rotation, { x: 0 });
      gsap.set(bottle.position, { y: LOWER_Y });
    },

    onUpdate: (self) => {

      if (!isActive) return; // 🔥 MOST IMPORTANT FIX

      const progress = self.progress;

      /* ===== SCALE ===== */
      const currentScale =
        BIG_SCALE + (SECTION5_SCALE - BIG_SCALE) * progress;

      // bottle.scale.set(currentScale, currentScale, currentScale);
      gsap.to(bottle.scale, {
  x: currentScale,
  y: currentScale,
  z: currentScale,
  duration: 0.15,           // 🔥 smoothness control
  ease: "power2.out",
  overwrite: "auto"
});

      /* ===== BOX ===== */
      bottle.traverse(child => {
        if (child.userData.isBox) {
          child.visible = true;
        }
      });

      /* ===== ROTATION ===== */
      bottle.rotation.x = -0.55 + (0.35 * progress);

      /* ===== POSITION ===== */
      bottle.position.y =
        LOWER_Y +
        (FALL_Y - LOWER_Y) * progress +
        (progress * 3.5);

      /* ===== ANIMATION ===== */
      if (action) {
        const duration = action.getClip().duration;
        action.time = duration * progress;
      }

      /* ===== IMAGE ===== */
      if (progress > 0.85) {
        gsap.to(".left-img, .right-img", {
          opacity: 1,
          y: 0,
          duration: 0.5,
          overwrite: "auto"
        });
      } else {
        gsap.to(".left-img, .right-img", {
          opacity: 0,
          y: 80,
          duration: 0.3,
          overwrite: "auto"
        });
      }
    }
  });


  /* ========================= GLOBAL RESET ========================= */
  ScrollTrigger.addEventListener("refreshInit", () => {
    if (!bottle) return;

    bottle.scale.set(ENTRY_SCALE, ENTRY_SCALE, ENTRY_SCALE);
    bottle.position.set(0, LOWER_Y, 20);
    bottle.rotation.set(-0.35, 0, 0);
  });

}

/* ========================= FLOATING ========================= */
function initSnakeLines() {

  const loader = new THREE.GLTFLoader();

  document.querySelectorAll(".panel").forEach((section, index) => {

    const direction = index % 2 === 0 ? 1 : -1;

    loader.load("https://cdn.shopify.com/3d/models/cd4ac39583194301/leaf_animation.glb", (gltf) => {

      const floatModel = gltf.scene;

      floatModel.scale.set(14, 14, 14);
      floatModel.visible = false;

      scene.add(floatModel);

      const distance = Math.abs(camera.position.z - (-12));
      const vFOV = THREE.MathUtils.degToRad(camera.fov);

      const height = 2 * Math.tan(vFOV / 2) * distance;
      const width  = height * camera.aspect;

      const startX = -width * 0.6;
      const endX   =  width * 0.6;

      const curve = new THREE.CubicBezierCurve3(
        new THREE.Vector3(startX, direction * 1, -12),
        new THREE.Vector3(startX * 0.3, direction * 2, -12),
        new THREE.Vector3(endX * 0.3, direction * 2, -12),
        new THREE.Vector3(endX, direction * 1, -5)
      );

      const progress = { t: 0 };

      gsap.to(progress, {
        t: 1,
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top bottom",
          end: "bottom top",
          scrub: 3,

          onEnter: () => floatModel.visible = true,
          onLeave: () => floatModel.visible = false,
          onEnterBack: () => floatModel.visible = true,
          onLeaveBack: () => floatModel.visible = false
        },

        onUpdate: () => {
          const point = curve.getPoint(progress.t);

          const floatY =
            Math.sin(progress.t * Math.PI * 4) * 1.2 * direction;

          floatModel.position.set(
            point.x,
            point.y + floatY,
            point.z
          );

          floatModel.rotation.z += 0.01 * direction;
        }
      });
    });
  });
}

/* ========================= RESIZE ========================= */
window.addEventListener("resize", updateViewport);



